import React, { useState, useEffect } from "react";
import { compose, graphql } from 'react-apollo';
import { Spin } from "antd";
import moment from 'moment';
import AntTable from "../../common/Table"; 
import { removeVoucherM } from "../../../graphql/mutation/voucher";
import columns from "../../../const/columns/vouchers";
import { openNotificationWithIcon } from "../../common/Notification";
import routes from "../../../const/routes";
import RefreshButton from "../../common/RefreshButton";
import { formatDate } from "../../../functions/formatDate";
import VoucherModal from "./components/VoucherModal";
import FilterPeriod from "../../../components/common/FilterPeriod";
import { handleInput } from "../../../functions/handleInputs";

function Vouchers({props, removeVoucher}){
    let [ vouchers, setVouchers ] = useState([]);
    let [ visible, setVisible ] = useState(false); 
    let [ idVoucher, setIdVoucher ] = useState(undefined); 
    let [ period, setPeriod ] = useState({
        begin: formatDate(moment().startOf('month').format()),
        end: formatDate(moment().endOf('month').format()),
        status: "EM ANALISE"
    });

    useEffect(() => {
        if(props.vouchers.data && props.vouchers.data.data && props.vouchers.data.data.vouchers && props.vouchers.data.data.message === "Vouchers Found."){

            let vouchersCopy = props.vouchers.data.data.vouchers.slice();

            vouchersCopy.map(voucher => {
                props.vouchers.data.data.rooms.map(room => {
                    if(voucher.room && voucher.room[0] && voucher.room[0] === room._id){
                        voucher.sala = room.name;
                        voucher.branch = room.branch[0];
                    }
                    return null
                })
                return null
            })

            vouchersCopy.map(voucher => {
                props.vouchers.data.data.branchs.map(branch => {
                    if(voucher.branch && voucher.branch === branch._id){
                        voucher.filial = branch.name;
                    }
                    return null
                })
                return null
            })

            vouchersCopy.map(voucher => {
                voucher.beginDate = formatDate(moment(voucher.beginDate).format());
                voucher.endDate = formatDate(moment(voucher.endDate).format());
                return null
            })

            vouchersCopy = vouchersCopy.reverse();

            setVouchers(vouchersCopy)
        }
    }, [props.vouchers]);

    useEffect(() => {
        getVOuchers()
    }, []);

    function getVOuchers(){
        let body = {
            period,
            filter: "",
        };

        props.GET_VOUCHERS(body)
    }
 
 
    async function deleteF(id){
        let body = {
            _id: id,
            removeVoucher 
        };
    
        await props.REMOVE_VOUCHER(body);

        let newVouchers = vouchers.slice();
        newVouchers = newVouchers.filter(voucher => {
            if(voucher._id !== id) return voucher
            else return null
        })
        setVouchers(vouchers = newVouchers);


        setTimeout(() => {getVOuchers()},100)
        openNotificationWithIcon('success', "Sucesso", "Voucher deletado com sucesso", "", 7);
    }

    function update(id){
        localStorage.setItem('@Ossel:Update', true);
        localStorage.setItem('@Ossel:UpdateID', id);
    }
    
    function showVoucherModal(id){
        setIdVoucher(idVoucher = id);
        setTimeout(() => {setVisible(visible = true)},5)
    }

    return(
        <Spin spinning={props.vouchers.loading}> 
            <FilterPeriod
                action={getVOuchers}
                handleInput={handleInput}
                period={period}
                setPeriod={setPeriod}
            />
            <RefreshButton clickAction={getVOuchers}/>
            <VoucherModal visible={visible} setVisible={setVisible} idVoucher={idVoucher}/>
            <Spin spinning={props.vouchers.loading}>
                <AntTable 
                    dataSource={vouchers} 
                    columns={columns} 
                    new={routes.VOUCHERS_FORM} 
                    delete={deleteF} 
                    update={update}
                    btEdit={false}
                    hideBtnNew={false}
                    btViewVoucher={true}
                    showVoucherModal={showVoucherModal}
                />
            </Spin>
        </Spin>
    )
}

export default compose(
    graphql( removeVoucherM, { name: "removeVoucher" } )
)(Vouchers);


// WEBPACK FOOTER //
// ./src/components/general/vouchersWrapper/Vouchers.jsx